import React, {useState} from "react";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import CustomCurrencyInput from "../../components/CustomCurrencyInput";
import classnames from "classnames";
import Stack from "@mui/material/Stack";
import Tooltip from "@mui/material/Tooltip";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import {LEASE_DEAL_LIGHT, PURCHASE_DEAL_DARK} from "../../contexts/DealContext";
import KeyboardReturnIcon from "@mui/icons-material/KeyboardReturn";
import _ from "lodash";
import {useCalcContext} from "../../contexts/CalcContext";
import LocalOfferOutlinedIcon from '@mui/icons-material/LocalOfferOutlined';
import {CostCalculator} from "../../components/CostCalculator";
import Switch from "@mui/material/Switch";
import {useMediaQuery} from "react-responsive";
import {mediaQueryForMobile} from "../HomePage/HomePage";

export const CalcPagePricing = ({ deskDeal, createNewPurchase, getRebates }) => {
    const isTabletOrMobile = useMediaQuery({ query: mediaQueryForMobile })
    const [isCreatingLease, setIsCreatingLease] = useState(false)
    const [isCreatingPurchase, setIsCreatingPurchase] = useState(false)

    const {
        calcState,
        setCalcState,
        carState,
        isUsed
    } = useCalcContext()

    const isLoading = (isCreatingPurchase || isCreatingLease)

    const isInputDisabled = !carState.year || !carState.make || !carState.model || !carState.trim
    const isDisabled = !calcState.msrp || !calcState.cost || !calcState.base_car_id

    const sellingPrice =  _.round(Number(calcState.cost) + Number(calcState.profit), 2)
    const clearCostFields = () => {
        const fieldValues = {
            invoice_plus: '',
            invoice_minus: '',
            msrp_plus: '',
            msrp_minus: '',
            msrp_percentage: ''
        }
        setCalcState({...calcState, ...fieldValues})
    }

    return (
        <Box className={classnames("CalcPageInfo_box", {
            mobile: isTabletOrMobile
        })}>
            <Stack
                direction="column"
                justifyContent="space-between"
                style={{
                    height: '100%'
                }}
            >
                <div>
                    <Typography
                        variant="h6"
                        component="div"
                        className={'header'}
                    >
                        <LocalOfferOutlinedIcon sx={{color: '#2267CE'}}/>
                        <span>
                            Vehicle Pricing
                        </span>
                    </Typography>
                    <Divider className={'divider'} sx={{marginBottom: '10px'}}/>

                    {
                        !isUsed &&
                        <React.Fragment>

                            <div
                                className={'payment-row'}
                            >
                            <span
                                className={'payment-row_name'}
                            >
                                MSRP:
                            </span>
                                <CustomCurrencyInput
                                    className={classnames('payment-row_value', {
                                        loading: isLoading
                                    })}
                                    placeholder={'0'}
                                    value={calcState.msrp}
                                    onChange={(value) => setCalcState({...calcState, msrp: value})}
                                    allowNull={true}
                                    disabled={isInputDisabled}
                                />
                            </div>
                            <div
                                className={'payment-row'}
                            >
                            <span
                                className={'payment-row_name'}
                            >
                                Invoice:
                            </span>
                                <CustomCurrencyInput
                                    className={classnames('payment-row_value', {
                                        loading: isLoading
                                    })}
                                    prefix="$"
                                    value={calcState.invoice}
                                    onChange={(value) => setCalcState({...calcState, invoice: value})}
                                    disabled={isInputDisabled}
                                />
                            </div>
                        </React.Fragment>
                    }
                    {
                        isUsed &&
                        <React.Fragment>
                            <div
                                className={'payment-row'}
                            >
                            <span
                                className={'payment-row_name'}
                            >
                                Book Value:
                            </span>
                                <CustomCurrencyInput
                                    className={classnames('payment-row_value', {
                                        loading: isLoading
                                    })}
                                    prefix="$"
                                    value={calcState.msrp}
                                    onChange={(value) => {
                                        setCalcState({...calcState, invoice: value, msrp: value})
                                    }}
                                    disabled={isInputDisabled}
                                />
                            </div>
                            <div
                                className={'payment-row'}
                            >
                                <span
                                    className={'payment-row_name'}
                                >
                                    Certified Pre-Owned: <strong>{calcState.is_certified_preowned ? 'Yes' : 'No'}</strong>
                                </span>

                                <Switch
                                    size={'small'}
                                    checked={calcState.is_certified_preowned}
                                    onChange={(value) => setCalcState({
                                        ...calcState,
                                        is_certified_preowned: !calcState.is_certified_preowned
                                    })}
                                />
                            </div>
                            <div
                                className={'payment-row'}
                            >
                                <span
                                    className={'payment-row_name'}
                                >
                                    Current Mileage:
                                </span>
                                <CustomCurrencyInput
                                    className={classnames('payment-row_value', {
                                        loading: isLoading
                                    })}
                                    prefix="$"
                                    value={calcState.current_mileage}
                                    onChange={(value) => setCalcState({...calcState, current_mileage: value})}
                                    disabled={isInputDisabled}
                                    InputProps={{}}
                                />
                            </div>
                        </React.Fragment>
                    }
                    <div
                        className={'payment-row'}
                    >
                            <span
                                className={'payment-row_name'}
                            >
                                Cost: <CostCalculator state={calcState} setState={setCalcState} isLoading={isLoading}/>
                            </span>
                        <CustomCurrencyInput
                            className={classnames('payment-row_value', {
                                loading: isLoading
                            })}
                            placeholder={'0'}
                            value={calcState.cost}
                            onChange={(value) => setCalcState({...calcState, cost: value})}
                            onKeyDown={clearCostFields}
                            allowNull={true}
                            disabled={isInputDisabled}
                    />
                </div>
                    <div
                            className={'payment-row'}
                        >
                            <span
                                className={'payment-row_name'}
                            >
                                Profit:
                            </span>
                        <CustomCurrencyInput
                            className={classnames('payment-row_value', {
                                loading: isLoading
                            })}
                            prefix="$"
                            placeholder={calcState.profit}
                            value={calcState.profit}
                            onChange={(value) => setCalcState({...calcState, profit: value})}
                            disabled={isInputDisabled}
                        />
                    </div>
                    <Divider className={'divider'} sx={{marginBottom: '10px'}}/>
                    <div
                        className={'payment-row'}
                    >
                            <span
                                className={'payment-row_name'}
                            >
                                Selling Price:
                            </span>
                        <CustomCurrencyInput
                            className={classnames('payment-row_value disabled', {
                                loading: isLoading
                            })}
                            value={sellingPrice}
                            disabled={true}
                        />
                    </div>
                    <Divider className={'divider'}/>
                </div>
                <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="end"
                >
                    <Tooltip title="Press Enter to Calculate" arrow placement={'bottom'}>
                            <span>
                                <Button
                                    className={classnames('dealPage-button', {
                                        isDisabled: isDisabled
                                    })}
                                    style={{background: '#2267CE'}}
                                    onClick={() => deskDeal(false, false)}
                                    disabled={isDisabled}
                                >
                                    {
                                        isCreatingLease ? 'Calculating...' : 'Lease'
                                    }
                                    {
                                        isCreatingLease ? null : <KeyboardReturnIcon/>
                                    }
                                </Button>
                            </span>
                    </Tooltip>
                    <span>
                            <Button
                                className={classnames('dealPage-button', {
                                    isDisabled: isDisabled
                                })}
                                style={{
                                    background: '#FFFFFF',
                                    color: PURCHASE_DEAL_DARK,
                                    border: `1px solid`
                                }}
                                onClick={() => deskDeal(true, false)}
                                disabled={isDisabled}
                            >
                                {
                                    isCreatingPurchase ? 'Calculating...' : 'Finance'
                                }
                            </Button>
                        </span>
                        <span>
                            <Button
                                className={classnames('dealPage-button', {
                                    isDisabled: isDisabled
                                })}
                                style={{
                                    background: '#FFFFFF',
                                    color: PURCHASE_DEAL_DARK,
                                    border: `1px solid`
                                }}
                                onClick={() => deskDeal(true, true)}
                                disabled={false}
                            >
                                {
                                    isCreatingPurchase ? 'Calculating...' : 'Cash'
                                }
                            </Button>
                        </span>
                </Stack>
            </Stack>
        </Box>
    )
}